module.exports = __webpack_public_path__ + "static/forcedrift.2439dc7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apps/bcj/forcedrift.png
// module id = 755
// module chunks = 168707334958949